<template>
    <el-dialog
        class="message-notice-dialog"
        :visible="noticeDialogShow"
        width="680px"
        :before-close="closeHandle"
        :close-on-click-modal="false"
    >
        <div class="slot-title" slot="title">
            <div
              class="slot-title-top"
            >{{noticeInfo.title}}</div>
        </div>
<!--      没有显示时间 -->
<!--        <div class="self-title">
            <div class="notice-title">{{}}</div>
            <div class="time">{{noticeDialogInfo.updateTime}}</div>
        </div>-->
        <div class="content-outer">
            <el-scrollbar style="height: 100%;">
                <div class="content ql-container" v-html="noticeInfo.content"></div>
            </el-scrollbar>
        </div>
    </el-dialog>
</template>

<script>
  export default {
    name: 'noticeDialog',
    props: {
      noticeDialogShow:{
        type: Boolean,
        default: false,
      },
      noticeInfo: {
        type: Object,
        default(){
          return {}
        }
      },
    },
    methods: {
      closeHandle(){
        this.$emit('close');
      }
    }
  };
</script>
<style lang="scss" scoped>
    .message-notice-dialog {
        .slot-title {
            .slot-title-top {
                font-size: 14px;
                color: #6E6B7B;
                font-weight: 600;
            }
            .slot-title-bot {
                font-size: 12px;
                color: #666666;
                margin-top: 10px;
            }
        }
        .content-outer {
            //min-height: 300px;
            height: 60vh;
            .content {
                padding: 20px;
                padding-top: 0;
            }
        }
        .btn-outer {
            width: 100%;
            text-align: center;
            padding-top: 20px;
            padding-bottom: 10px;
        }
        .self-title{
            padding: 20px;
            .notice-title {
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                margin-bottom: 15px;
            }
        }
        .check-box-outer {
            text-align: left;
        }
    }
    @media screen and (max-width: 768px){
        .message-notice-dialog {
            .content-outer {
                height: 80vh;
            }
        }
    }
</style>

<style lang="scss">
    .message-notice-dialog {
        img {
            max-width: 100%;
        }
        .el-dialog__header {
            background-color: #F8F8F8;
            padding-top: 10px;
            padding-bottom: 10px;
        }
        .el-dialog {
            margin-top: 7%!important;
            border-radius: 10px;
            overflow: hidden;
            .el-dialog__body {
                padding: 0;
              padding-top: 20px;
            }
        }
      .el-dialog__headerbtn {
        top: 10px;
      }
    }
</style>
